var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styles } from './styles';
import { registerCustomElement } from '../utils/registerCustomElement';
let Checkbox = class Checkbox extends LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.id = '';
        this.checked = false;
        this.disabled = false;
        this.onChange = () => { };
    }
    render() {
        const containerClasses = {
            'checkbox-container': true,
            checked: this.checked,
            disabled: this.disabled,
        };
        return html `
      <div class=${classMap(containerClasses)}>
        <grain-icon
          name=${this.checked ? 'selectedCheckbox' : 'unselectedCheckbox'}
          exportparts="grain-icon-svg-wrapper"
          width="16px"
          height="17px"
        ></grain-icon>
        <input
          type="checkbox"
          ?disabled=${this.disabled}
          id=${this.id}
          class="checkbox"
          checked=${this.checked}
          @change=${this.onChange}
        />
        <label class="label" for=${this.id}>${this.label}</label>
      </div>
    `;
    }
};
Checkbox.styles = styles;
__decorate([
    property({ type: String })
], Checkbox.prototype, "label", void 0);
__decorate([
    property({ type: String })
], Checkbox.prototype, "id", void 0);
__decorate([
    property({ type: Boolean })
], Checkbox.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean })
], Checkbox.prototype, "disabled", void 0);
__decorate([
    property({ type: Function })
], Checkbox.prototype, "onChange", void 0);
Checkbox = __decorate([
    registerCustomElement('grain-checkbox')
], Checkbox);
export { Checkbox };
